<template>
  <div
    class="panel-row-without-selector-res mb-3 py-3 gray border-radius--light border-gray"
  >
    <div class="col-md-2 pt-0 info">
      <slot name="firstColumn" />
    </div>
    <div class="col-md-3 pt-xs-4 info">
      <slot name="secondColumn" />
    </div>
    <div class="col-md-3 pt-xs-4 info">
      <slot name="thirdColumn" />
    </div>
     <div class="col-md-2 pt-xs-4 info">
      <slot name="fourthColumn" />
    </div>    
    <div v-if="inDropdown" class="col-sm-12 col-md-2 info text-right pt-2 px-0">
      <dropdown
        class="mx-3"
        :items="actions"
        :title="'Acciones'"
        :responsive="true"
      />
    </div>
    <div v-if="!inDropdown" class="col-sm-12 col-md-2 info text-right pt-2">
      <div class="pb-0">
        <span v-for="action in actions" :key="action.name">
          <a
            v-if="!action.disabledOnView"
            :class="`btn custom-class mr-2 btn-small ${action.btnClass}`"
            :data-node="node"
            @click="action.click"
          >
            <i :data-node="node" :class="`fas ${action.icon} pr-1`" />
          </a>
        </span>
      </div>
    </div>
    <div class="col-md-2 info mt-2">
      <slot name="fifthColumn" />
    </div>
    <div class="col-md-2 info mt-2">
      <slot name="sixthColumn" />
    </div>
  </div>
</template>

<script>
import Dropdown from 'dropdown';

export default {
  name: 'DocumentLayout',
  components: {
    Dropdown,
  },
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    node: {
      type: Number,
      default: 0,
    },
    isRow: {
      type: Boolean,
      default: true,
    },
    inDropdown: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.btn-dropdown-actions {
  border-color: #2b9d71 !important;
  width: 100%;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
  text-decoration: none !important;
}

.border-gray {
  border-left: solid 5px;
  border-color: #e8e8e8;
  border-color: #e8e8e8;
}

.btn {
  font: 16px/29px Lato;
  border: 1px solid;
}

@media (max-width: 575px) {
  .pt-xs-4,
  .py-xs-4 {
    padding-top: 1.5rem !important;
  }

  .mt-xs-4 {
    margin-top: 1.5rem !important;
  }
}
@media all and (max-width: 480px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}
</style>
